<template>
  <div class="filterCondition">
    <div>{{ $t('components.FilterCondition.settingLabel') }}</div>
    <div class="filterCondition__container">
      <div v-if="formValues['query']" class="labelsContainer">
        <span v-if="terms(formValues['query']).length >= 2" class="conditionLabel">
          {{ $t('components.FilterCondition.label.keywords_with_and_search') }}:
        </span>
        <span v-else class="conditionLabel">
          {{ $t('components.FilterCondition.label.keyword') }}:
        </span>
        <template v-for="(term, i) in terms(formValues['query'])" :key="i">
          <KkTag :label="term" class="labels__item" :clickable="clickableTag" @click="openSettingKeywordModal(term)" />
        </template>
      </div>
      <div class="firstSingleLine">
        <template v-for="cond in filterConditions.filter(v => v.isDisplaySingleLine)">
          <div v-if="cond.tags.length !== 0" :key="cond.name" class="labelsContainer">
            <span class="conditionLabel">{{ cond.name }}:</span>
            <MoreItem
              :items="cond.tags"
              :display-length="6"
            />
          </div>
        </template>
      </div>
      <template v-for="cond in filterConditions.filter(v => !v.isDisplaySingleLine)">
        <div v-if="cond.tags.length !== 0" :key="cond.name" class="labelsContainer">
          <span class="conditionLabel">{{ cond.name }}:</span>
          <MoreItem
            :items="cond.tags"
            :display-length="6"
          />
        </div>
      </template>
    </div>
    <div v-if="canSave" class="buttonWrapper">
      <button class="c-button__item c-button__item--outline" @click.prevent="clickOpenSettingEmailNotificationModal">{{ $t('components.FilterCondition.settingEmail') }}</button>
    </div>
  </div>
</template>

<script>
import MoreItem from './MoreItem'
import { KkTag } from '../components/base'
import { searchQueryAnalyzer } from '../modules/searchQueryAnalyzer'
import { actionEvent } from 'src/biz_spa/modules/googleAnalytics'

export default {
  name: 'FilterCondition',
  components: {
    MoreItem,
    KkTag
  },
  props: {
    searchAttributes: {
      type: Object,
      require: true
    },
    formValues: {
      type: Object,
      require: true
    },
    disableFilterItemTypes: {
      type: Array,
      default: () => []
    },
    displayFirstSingleLineTypes: {
      type: Array,
      default: () => []
    },
    canSave: {
      type: Boolean,
      default: () => true
    },
    clickableTag: {
      type: Boolean,
      default: false
    }
  },
  emits: ['open-setting-email-notification-modal', 'open-setting-keyword-modal'],
  computed: {
    filterItems() {
      // ユーザーが使いやすいように項目の並び順を意識すること
      const arr = [
        this.addAttributes(this.searchAttributes.topic_types, this.searchAttributes.topic_types.kind),
        this.addAttributes(this.searchAttributes.comments, this.searchAttributes.comments.kind),
        this.addAttributes(this.searchAttributes.replies, this.searchAttributes.replies.kind),
        this.addAttributes(this.searchAttributes.locales, this.searchAttributes.locales.kind),
        this.addAttributes(this.searchAttributes.emails, this.searchAttributes.emails.kind),
        this.addAttributes(this.searchAttributes.ratings, this.searchAttributes.ratings.kind),
        this.addAttributes(this.searchAttributes.keyword_analysis_targets, this.searchAttributes.keyword_analysis_targets.kind),
        this.addAttributes(this.searchAttributes.sites, this.searchAttributes.sites.kind),
        this.addAttributes(this.searchAttributes.brands, this.searchAttributes.brands.kind),
        this.addAttributes(this.searchAttributes.competitor_brands, this.searchAttributes.competitor_brands.kind),
        this.addAttributes(this.searchAttributes.prefectures, this.searchAttributes.prefectures.kind),
        this.addAttributes(this.searchAttributes.areas, this.searchAttributes.areas.kind),
        this.addAttributes(this.searchAttributes.franchisees, this.searchAttributes.franchisees.kind),
        this.addAttributes(this.searchAttributes.user_companies, this.searchAttributes.user_companies.kind),
        this.addAttributes(this.searchAttributes.stores, this.searchAttributes.stores.kind),
        this.addAttributes(this.searchAttributes.competitors, this.searchAttributes.competitors.kind),
      ]
      if(this.searchAttributes.original_tag_group_a) arr.push(this.addAttributes(this.searchAttributes.original_tag_group_a, this.searchAttributes.original_tag_group_a.kind))
      if(this.searchAttributes.original_tag_group_b) arr.push(this.addAttributes(this.searchAttributes.original_tag_group_b, this.searchAttributes.original_tag_group_b.kind))
      if(this.searchAttributes.original_tag_group_c) arr.push(this.addAttributes(this.searchAttributes.original_tag_group_c, this.searchAttributes.original_tag_group_c.kind))
      if(this.searchAttributes.original_tag_group_d) arr.push(this.addAttributes(this.searchAttributes.original_tag_group_d, this.searchAttributes.original_tag_group_d.kind))
      if(this.searchAttributes.original_tag_group_e) arr.push(this.addAttributes(this.searchAttributes.original_tag_group_e, this.searchAttributes.original_tag_group_e.kind))

      return arr.filter(v => !this.disableFilterItemTypes.includes(v.type))
    },
    filterConditions() {
      return this.filterItems.map(item => {
        const tags = item.tags.filter(tag => {
          const valueKey = item.valueKey ? item.valueKey : 'id'
          return this.formValues[item.type].includes(tag[valueKey])
        })
        return { name: item.filterName, tags: tags.map(v => v.name), isDisplaySingleLine: this.displayFirstSingleLineTypes.includes(item.type) }
      })
    }
  },
  methods: {
    addAttributes(item, type) {
      item.type = type
      item.filterName = this.$te('models.filterItem.' + type + '.filterName') ? this.$t('models.filterItem.' + type + '.filterName') : item.label
      switch (type) {
      case 'comments':
        item.valueKey = 'value'
        break
      case 'ratings':
        item.valueKey = 'value'
        break
      case 'emails':
        item.valueKey = 'value'
        break
      case 'replies':
        item.valueKey = 'value'
        break
      case 'keyword_analysis_targets':
        item.valueKey = 'value'
        break
      case 'topic_types':
        item.valueKey = 'value'
        break
      }
      return item
    },
    clickOpenSettingEmailNotificationModal(){
      this.$emit('open-setting-email-notification-modal')
      if (this.$route.name === 'CompaniesReviews') {
        actionEvent('ReceiveEmail')
      }
    },
    terms(query) {
      return searchQueryAnalyzer(query)
    },
    openSettingKeywordModal(term) {
      this.$emit('open-setting-keyword-modal', term)
    }
  }
}
</script>

<style lang="scss" scoped>
.filterCondition {
  background: #ECEDF0;
  padding: 20px;
  display: flex;

  @media screen and (max-width: 768px) {
    display: block;
  }

  &__container {
    width: 60%;
    margin-left: 20px;

    @media screen and (max-width: 768px) {
      margin-left: 0;
    }
  }
}

.conditionLabel {
  font-weight: bold;
  margin-right: 10px;
  white-space: nowrap;
}

.labelsContainer {
  display: flex;
  margin: 0 10px 10px 0;
}

.firstSingleLine {
  display: flex;
  @media screen and (max-width: 768px) {
    display: block;
  }
}

.buttonWrapper {
  margin-left: auto;
}

.c-button__item {
  font-weight: normal;

  @media screen and (max-width: 768px) {
    margin: 0;
  }
  @media screen and (max-width: 340px) {
    margin-left: -10px;
  }
}
</style>
